import CoursesApiService from "./api/CoursesApiService";
import { formatPayloadToQueryString } from "@/utils/formatters";
export const getOrganizations = async (payload, userToken) => {
    try {
        const response = await CoursesApiService.get(`/organizations${formatPayloadToQueryString(payload)}`, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
        return response.data;
    }
    catch (error) {
        console.error('Erro ao buscar organizações', error);
        throw error;
    }
};
export const getOrganizationById = async (organizationId, userToken) => {
    try {
        const response = await CoursesApiService.get(`/organizations/${organizationId}`, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
        return response.data;
    }
    catch (error) {
        console.error('Erro ao buscar organização', error);
        throw error;
    }
};
export const createOrganization = async (payload, userToken) => {
    try {
        const response = await CoursesApiService.post('/organizations', payload, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
        return response.data;
    }
    catch (error) {
        console.error('Erro ao criar organização', error);
        throw error;
    }
};
export const updateOrganization = async (payload, userToken) => {
    const { id, ...organization } = payload;
    try {
        const response = await CoursesApiService.put(`/organizations/${id}`, organization, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
        return response.data;
    }
    catch (error) {
        console.error('Erro ao atualizar organização', error);
        throw error;
    }
};
export const deleteOrganization = async (organizationId, userToken) => {
    try {
        await CoursesApiService.delete(`/organizations/${organizationId}`, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
    }
    catch (error) {
        console.error('Erro ao deletar organização', error);
        throw error;
    }
};
export default {
    getOrganizations,
    getOrganizationById,
    createOrganization,
    updateOrganization,
    deleteOrganization
};
